import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Remote(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.848 5.74l1.376 1.375a1.168 1.168 0 011.6 1.6L18.2 10.09a3.003 3.003 0 010 4.243l-7.727 7.726a2.978 2.978 0 01-2.121.88 2.978 2.978 0 01-2.121-.88H6.23l-4.352-4.352A2.983 2.983 0 011 15.588c0-.802.312-1.556.878-2.123L9.605 5.74c1.133-1.133 3.11-1.133 4.243 0zm-2.122 1.12a.993.993 0 00-.707.293L3.292 14.88a.995.995 0 00-.292.707c0 .267.103.518.292.707l4.353 4.352a1.021 1.021 0 001.414 0l7.727-7.726a1.003 1.003 0 000-1.414l-4.352-4.353a.996.996 0 00-.708-.293zM7.562 12.83l1.067 1.066 1.067-1.066a.999.999 0 111.414 1.414l-1.067 1.066 1.067 1.068a.999.999 0 11-1.414 1.414L8.63 16.723l-1.067 1.068a.997.997 0 01-1.414 0 .999.999 0 010-1.414l1.067-1.068-1.067-1.066a.999.999 0 111.414-1.414zm6.44-1.228l.942.942a.999.999 0 11-1.414 1.414l-.942-.942a.999.999 0 111.414-1.414zm-2.606-2.606l.942.942a.999.999 0 11-1.414 1.414l-.942-.942a.999.999 0 111.414-1.414zm7.255-3.728c1.395 1.396 1.3 2.891 1.284 3.057a1 1 0 01-1.993-.167v-.046c-.005-.177-.069-.794-.68-1.405-.647-.647-1.28-.7-1.44-.704h-.039c-.528.025-1.019-.386-1.057-.929a.991.991 0 011.001-1.071h.125c.503.01 1.693.157 2.8 1.265zm-2.54-4.26c.076.004.15.017.222.037 1.037.089 2.834.497 4.46 2.122 1.718 1.718 2.087 3.616 2.154 4.595a1.002 1.002 0 01-.93 1.066l-.07.002c-.52 0-.96-.404-.996-.932-.058-.854-.378-2.124-1.572-3.317-1.263-1.263-2.642-1.515-3.352-1.552a1.002 1.002 0 01-.182-.026c-.15-.005-.26.002-.322.008a1 1 0 01-.182-1.992 5.77 5.77 0 01.77-.01z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoRemote = React.memo(Remote);
export default MemoRemote;